import { useState } from "react";
import { api } from "../api";

interface Props {
  token: string;
}

export function Reset({ token }: Props) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (password.length < 12) {
      setErr("Password must be at least 12 characters.");
      return;
    }
    if (password !== confirm) {
      setErr("Passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await api.confirmPasswordReset(token, password);
      setDone(true);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "reset_failed");
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <h1>Password updated</h1>
          <p className="muted">You can now sign in with your new password.</p>
          <div style={{ marginTop: 16 }}>
            <a href="/">Go to sign-in</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <h1>Choose a new password</h1>
        <p className="muted">Use at least 12 characters.</p>
        <label>New password</label>
        <input
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={12}
        />
        <label>Confirm password</label>
        <input
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
          minLength={12}
        />
        <div style={{ marginTop: 16 }}>
          <button type="submit" disabled={busy}>
            {busy ? "Saving…" : "Save password"}
          </button>
        </div>
        {err && <div className="error">{err}</div>}
      </form>
    </div>
  );
}
